export default __webpack_public_path__ + "d4ea413601d1b21b4875b52f5420cba7.png";